 
  <div *ngFor="let item of selectables">
    <input type="checkbox" [value]="item" [(ngModel)]="item.checked" (change)="onCheckBoxChange(item)" />
    <span class="ms-2">{{ item.name }}</span>
  </div>
 
